import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const TrimbleIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Trimble Icon</title>;
    t1 = <path fill="#0063a3" d="M14.41 14.14c-.1-.87-.3-1.73-.62-2.54a4.03 4.03 0 0 1-4.18-.76c-.83.86-1.57 1.81-2.22 2.81 1.91 1.56 5.05 1.97 7.02.49M9.63 9.53c.59-.55 1.23-1.06 1.9-1.51a6.2 6.2 0 0 0-2.1-1.27c-.56.87-.48 2.01.2 2.79m2.59-2.02c.46-.34.95-.61 1.48-.82a3.16 3.16 0 0 0-3.56-.59c.77.34 1.48.82 2.09 1.41m-6.26-.97c-1.34 1.9-.71 4.67.84 6.41a20 20 0 0 1 2.26-2.84c-.86-1-1.03-2.42-.4-3.59-.89-.22-1.82-.21-2.7.02m2.7-.02 5.49 3.71c.66-.84.67-2.02.03-2.87-.5.2-.96.48-1.38.81.53.63.99 1.32 1.35 2.06M9.23 5.67c.59-.42 1.29-.65 2.01-.67-1.48-.25-3-.08-4.39.5.8-.09 1.61-.03 2.38.17m4.27 5.09c-.36-.76-.82-1.46-1.36-2.09-.68.45-1.32.96-1.92 1.51.9.79 2.17 1.02 3.28.58m1.95-2.11c.13.92-.23 1.84-.94 2.45.29.74.51 1.5.64 2.28a4.69 4.69 0 0 0 .3-4.73m-.17 5.91c.02.57 0 1.15-.08 1.72a6.82 6.82 0 0 0 1.42-4.75c-.1 1.13-.57 2.19-1.34 3.03m5.75-2.54-3.97-2.3c.47 1.5.46 3.1-.02 4.6zM6.99 14.51c-.58.95-1.01 1.99-1.26 3.08a6.8 6.8 0 0 0 8.38-.15c.27-.7.4-1.45.38-2.2a6.94 6.94 0 0 1-7.5-.73m-.62-.72a6.65 6.65 0 0 1-1.73-6.18 6.787 6.787 0 0 0 .4 9.21c.31-1.07.76-2.09 1.34-3.03M8.19 4.3 4.24 2.03v4.55a7.56 7.56 0 0 1 3.95-2.27ZM4.24 22.01l3.98-2.3a7.6 7.6 0 0 1-3.98-2.28z" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};